/*
 *constants to define maximum lengths of the fields within the form
 */

export const CLASS_DESCRIPTION_MAXIMUM_LENGTH = 20;

export const CLASS_CATEGORY_DESCRIPTION_MAXIMUM_LENGTH = 40;

export const CLASS_GROUP_DESCRIPTION_MAXIMUM_LENGTH = 40;
